export const USER_PREFERENCES = {
	SIDENAV_PINNED: 'sidenav_pinned',
	NAV_SHORTCUTS: 'nav_shortcuts',
	LAST_SEEN_CHANGELOG_VERSION: 'last_seen_changelog_version',
	SPAN_DETAILS_PINNED_ATTRIBUTES: 'span_details_pinned_attributes',
	SPAN_PERCENTILE_RESOURCE_ATTRIBUTES: 'span_percentile_resource_attributes',
};
